import {
  Button,
  Divider,
  Form,
  Input,
  Drawer,
  Select,
  Space,
  Tooltip,
} from "antd";
import React, { useRef } from "react";
import ItemsService, { UnitTypesOption } from "../../../Services/ItemsService";
import { useClient } from "../../../Context/ClientContext";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { allCountriesStates } from "../../../../Types/CommonAllCountriesStates";
import CurrencyServices from "../../../Services/CurrencyServices";
import { CloseOutlined } from "@ant-design/icons";
import { useHotkey } from "../../../Context/HotKeyContext";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";

const AddCurrenct: React.FC<{
  open: boolean;
  data: any;
  setTrigger: any;
  onCancel: any;
  setAddUnitVal?: (param: string) => void;
}> = (props) => {
  const { showKeys } = useHotkey();
  console.log("props", props);
  const autoCompleteRef = useRef<any>(null);
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const { openNotification } = React.useContext(notificationContext);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);

  const countryOptions = allCountriesStates.map((x) => ({
    label: x?.iso3 + " - " + x?.name + " (" + x?.currency_symbol + ")",
    value: x.iso2,
  }));

  // Post Api
  const postItem = () => {
    form.validateFields().then(async (x: any) => {
      setSaveButtonLoading(true);
      let data = {
        ...x,
        country: {
          id: x.country.value,
          name: x.country.label,
        },
      };

      await CurrencyServices.postCurrency(
        data,
        currentClient?.id,
        props.data?.id
      )
        .then((res: any) => {
          if (res.result) {
            props?.setAddUnitVal && props?.setAddUnitVal(res?.result);
            openNotification(
              "success",
              `Currency ${
                props.data?.id ? "updated successfully." : "added successfully."
              }`
            );
            props.onCancel();
            setSaveButtonLoading(false);
            props.setTrigger((x: boolean) => !x);
            console.log(res);
          } else {
            setSaveButtonLoading(false);
            openNotification("error", res.message);
          }
        })
        .catch((ex: any) => {
          setSaveButtonLoading(false);
          openNotification("error", ex);
          console.error(ex);
        });
    });
  };

  // Get Api
  React.useEffect(() => {
    if (props?.data?.id) {
      form.setFieldsValue({ ...props.data });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.data.id]);
  // getItemInventory;

  // --------- InitialValues in Add Item Model ---------
  const initialValues = {};
  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.focus();
      }
    }, 100); // Adjust delay if needed

    return () => clearTimeout(timer);
  }, []); // Ensures autofocus after initial render

  EntryLevelKeys({
    save: () => postItem(),
    cancel: () => {
      form.resetFields();
      props.onCancel();
    },
  });

  return (
    <div>
      <Drawer
        open={props.open}
        title={props?.data.id ? "Update Currency" : "Add Currency"}
        width={500}
        onClose={() => props.onCancel()}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => props.onCancel()} />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Tooltip
              title={<p>ALT+C</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                onClick={() => {
                  form.resetFields();
                  props.onCancel();
                }}
              >
                Cancel
              </Button>
            </Tooltip>
            <Tooltip
              title={<p>ALT+S</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                className="modelSaveButtonMargin"
                type="primary"
                onClick={() => postItem()}
                loading={saveButtonLoading}
              >
                {!props?.data.id ? "Save" : "Update"}
              </Button>
            </Tooltip>
          </div>
        }
      >
        <Form
          form={form}
          name="item"
          autoCapitalize="false"
          requiredMark={true}
          initialValues={initialValues}
          colon={false}
          labelAlign="left"
          // labelCol={{ xs: 10, sm: 9 }}
          // wrapperCol={{ xs: 14, sm: 15 }}
          labelWrap={true}
          layout="vertical"
        >
          <Form.Item
            label="Country Name"
            name="country"
            rules={[{ required: true, message: "Country name is required" }]}
            className="input-item mb-14"
          >
            <Select
              labelInValue
              showSearch
              ref={autoCompleteRef}
              placeholder="Country Name"
              options={countryOptions}
              filterOption={(input, option) =>
                (option?.label?.toString() ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              onChange={(e) => {
                const countryDetails = allCountriesStates.find(
                  (x) => x.iso2 === e?.value
                );
                console.log("countryDetails", countryDetails);
                if (countryDetails) {
                  form.setFieldsValue({
                    currencySymbol: countryDetails?.currency_symbol,
                    currencyName: countryDetails?.currency_name,
                  });
                }
              }}
            />
          </Form.Item>

          <Form.Item
            label="Currency Symbol"
            name="currencySymbol"
            rules={[{ required: true, message: "Currency Symbol is required" }]}
            className="input-item mb-14"
          >
            <Input placeholder="Currency Symbol" />
          </Form.Item>

          <Form.Item
            rules={[{ required: true, message: "Currency Name is required" }]}
            label="Currency Name"
            name="currencyName"
            className="input-item"
          >
            <Input placeholder="Currency name" />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default AddCurrenct;
